import React from 'react'
import { useParams } from 'react-router';
import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import FilterFunctions from '../../../functions/public/filter';
import ProductGrid4 from '../../../components/public/pages/home/productGrid4';
import Bar from '../filter/bar';
import ScreenSizes from '../../../configTools/screenSizes';
import Mobilebar from '../filter/mobilebar';
import DocumentMeta from 'react-document-meta';

const Index = () => {
    const meta = {
    /*title: 'New Arrivals | Latest & trendy Products on KAAY',
    description: "Discover the latest products from various Brands, local vendors & artists in our New Arrivals section. From clothing, accessories, handmade crafts to unique gifts, there's something for everyone in our constantly updated selection. Our social commerce platform makes it easy for sellers to showcase their products & reach a wider audience.",
    */
    canonical: window.location.href
    /*canonical: 'http://example.com/path/to/page',
    meta: {
        charset: 'utf-8',
        name: {
            keywords: 'react,meta,document,html,tags'
        }
    }*/
  }
  const {value} = useParams();
  const [products,setProducts] = useState([]);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [searchParams] = useSearchParams();
  const getmore_Products = ()=>{
      var category = searchParams.get('category') || "0";
      var subcategory = searchParams.get('subcategory') || "0";
      var brand = searchParams.get('brand') || "0";
      var condition = searchParams.get('condition') || "0";
      var color = searchParams.get('color') || "0";
      var size = searchParams.get('size') || 0;
      var orderby = searchParams.get('orderby') || 0;
      FilterFunctions.HashtagGet({
          value: value,
          category:category,
          subcategory:subcategory,
          brand:brand,
          condition:condition,
          color:color,
          size:size,
          orderby:orderby,
          page:page
      },(data)=>{
          let prevPro = products;
          for (let index = 0; index < data.length; index++) {
              const element = data[index];
              prevPro.push(element);
          }
          setProducts(prevPro);
          setPage(page+1);
          if(data.length === 0){
              setHasMore(false);
          }
          else{
              setHasMore(true);
          }
      })
  }
  useEffect(()=>{
      var category = searchParams.get('category') || "0";
      var subcategory = searchParams.get('subcategory') || "0";
      var brand = searchParams.get('brand') || "0";
      var condition = searchParams.get('condition') || "0";
      var color = searchParams.get('color') || "0";
      var size = searchParams.get('size') || 0;
      var orderby = searchParams.get('orderby') || 0;
      FilterFunctions.HashtagGet({
          value:value,
          category:category,
          subcategory:subcategory,
          brand:brand,
          condition:condition,
          color:color,
          size:size,
          orderby:orderby,
          page:0
      },(data)=>{
          let prevPro = [];
          for (let index = 0; index < data.length; index++) {
              const element = data[index];
              prevPro.push(element);
          }
          setProducts(prevPro);
          setPage(1);
          if(data.length === 0){
              setHasMore(false);
          }
          else{
              setHasMore(true);
          }
      })
  },[
      searchParams.get('category'),
      searchParams.get('subcategory'),
      searchParams.get('brand'),
      searchParams.get('condition'),
      searchParams.get('color'),
      searchParams.get('size'),
      searchParams.get('orderby')
  ])
  const width = window.innerWidth;
  return (
      <div>
      <DocumentMeta {...meta} />
          <div style={{ margin:"30px 40px" }}>
              <div className='heading_pg_results_container'>
                <h3 style={{textAlign:"center",padding:"150px 10px 30px 10px",fontSize:"24px",fontWeight:"600"}}>#{value} Results</h3>
              </div>
                {width > ScreenSizes.Mobile &&
                <Bar baseUrl={`hashtag/${value}`} searchParams={searchParams}/>
                }
                {width <= ScreenSizes.Mobile &&
                <Mobilebar baseUrl={`hashtag/${value}`} searchParams={searchParams}/>
                }
              <InfiniteScroll 
                  dataLength={products.length}
                  next={getmore_Products}
                  hasMore={hasMore}
                  loader={<h1></h1>}
              >
                  <ProductGrid4 Products={products} Columns={5}/>   
              </InfiniteScroll>
          </div>
      </div>
  )
}

export default Index
